module.exports = __webpack_public_path__ + "static/media/albacore.6b53b011.jpg";